import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';
import { useParams } from 'react-router-dom';
import { useLeadByIdQuery } from 'api';

export const LeadTaskDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: { isFinalStatus } = {} } = useLeadByIdQuery({ id }, { skip: !id });
  return <EntityTaskDetails entityName={'LEAD'} isFinalStatus={isFinalStatus} />;
};
